import React, { useEffect } from 'react';
import { globalShortcutsService } from '../services/globalShortcutsService';
import GlobalEntitySearch from '../components/Space/GlobalEntitySearch/GlobalEntitySearch';
import { useGlobalEntitySearchStore } from '../stores/globalEntitySearchStore';

export const useGlobalEntitySearchShortcut = () => {
  const { isOpen, toggle, close } = useGlobalEntitySearchStore();

  useEffect(() => {
    globalShortcutsService.register({
      id: 'global_entity_search',
      key: 'k',
      modifiers: { cmd: true },
      description: 'Open global search',
      handler: () => {
        toggle();
      },
    });

    return () => globalShortcutsService.unregister('global_entity_search');
  }, [toggle]);

  const GlobalEntitySearchModal = isOpen
    ? <GlobalEntitySearch onClose={close} />
    : null;

  return { GlobalEntitySearchModal };
};
